"use strict";
/**
 * This potentially can be replaced by the much more succint String.repalce with special chars, but beware the Safari does not support ( negative ) lookbehinds
 *
 * export const getCdkClassFileName = (projectName: string) => projectName.replace(/(?<!^)([A-Z])/g, '-$1').toLowerCase() // does this match work? yes see unit test

 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMatches = exports.replacer = void 0;
// attempts to support vs code style search and replace regex with group placeholders as $1 $2 etc
const replacer = (regex, replacement, str) => {
    const res = regex.exec(str);
    if (res) {
        const [searched, ...groups] = res;
        groups.forEach((group, i) => {
            replacement = replacement.replace(`\$${i + 1}`, group);
        });
        str = str.replace(searched, replacement);
        (0, exports.replacer)(regex, replacement, str);
    }
    else {
        console.log('Res was null', { str, regex, res });
    }
    return str;
};
exports.replacer = replacer;
const getMatches = (regex, str, i = 0) => {
    let matches = [];
    if (regex.lastIndex === 0) {
        regex = new RegExp(regex, 'gm'); // in case we forget
    }
    const res = regex.exec(str);
    if (res) {
        const [searched, ...groups] = res;
        groups.forEach((group, i) => {
            matches.push(group);
        });
        matches = matches.concat((0, exports.getMatches)(regex, str, i + 1));
    }
    else {
        // console.log('Res was null', { str, regex, res, matches })
    }
    return matches;
};
exports.getMatches = getMatches;
